<template>
    <div class="container-fluid">
        <div class="row">
            <h5 class="akkurate-dark mb-0">Loan Status</h5>
        </div>
        <hr class="py-0" />
        <div class="row">
            <div class="col-md-6 col-xl-3 mb-4">
                <div class="card border-start-info py-2 card-shape home-box card-top-dashboard">
                    <div class="card-body">
                        <div class="row align-items-center no-gutters">
                            <div class="col-12 col-md-12 mb-3">
                                <div class="text-uppercase fw-bold text-sm mb-1"><span>Total Loans</span>
                                </div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase text-xs mb-1"><span>Count</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase fw-bold text-xs mb-1">
                                    <span>{{ total_loans_count }}</span>
                                </div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase text-xs mb-1"><span>Amount</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase fw-bold text-xs mb-1"><span>GHS
                                        {{ formatNumber(total_loans_amount) }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-3 mb-4">
                <div class="card border-start-success py-2 card-shape home-box card-top-dashboard">
                    <div class="card-body">
                        <div class="row align-items-center no-gutters">
                            <div class="col-12 col-md-12 mb-3">
                                <div class="text-uppercase fw-bold text-sm mb-1"><span>Active
                                        Loans</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase text-xs mb-1"><span>Count</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase fw-bold text-xs mb-1"><span>{{
                                    active_loans_count }}</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase text-xs mb-1"><span>Amount</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase fw-bold text-xs mb-1"><span>GHS {{
                                    active_loans_amount }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-3 mb-4">
                <div class="card border-start-info py-2 card-shape home-box card-top-dashboard">
                    <div class="card-body">
                        <div class="row align-items-center no-gutters">
                            <div class="col-12 col-md-12 mb-3">
                                <div class="text-uppercase fw-bold text-sm mb-1"><span>Loans in
                                        Arrears</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase text-xs mb-1"><span>Count</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase fw-bold text-xs mb-1"><span>{{
                                    loans_in_arrears_count }}</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase text-xs mb-1"><span>Amount</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase fw-bold text-xs mb-1"><span>GHS {{
                                    formatNumber(loans_in_arrears_amount) }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-3 mb-4">
                <div class="card border-start-info py-2 card-shape home-box card-top-dashboard">
                    <div class="card-body">
                        <div class="row align-items-center no-gutters">
                            <div class="col-12 col-md-12 mb-3">
                                <div class="text-uppercase fw-bold text-sm mb-1"><span>Loans Paid
                                        Off</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase text-xs mb-1"><span>Count</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase fw-bold text-xs mb-1"><span>{{
                                    loans_paid_off_count }}</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase text-xs mb-1"><span>Amount</span></div>
                            </div>
                            <div class="col-md-6 col-6">
                                <div class="text-uppercase fw-bold text-xs mb-1"><span>GHS {{
                                    formatNumber(loans_paid_off_amount) }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <h5 class="akkurate-dark mb-0">Loan Aging Summary</h5>
        </div>
        <hr class="py-0" />
        <div class="row">
            <div class="trans_details">
                <b-table striped bordered responsive id="loanAgingSummary" :busy.sync="isLoading"
                    :items="age_report_items" :fields="age_report_fields" :tbody-tr-class="rowClass" show-empty>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                    <template #empty="scope">
                        <h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
                    </template>
                    <template #cell(principal_balance)="data">
                        {{ displayNumber(data.item.principal_balance) }}
                    </template>
                    <template #cell(default_principal)="data">
                        {{ displayNumber(data.item.default_principal) }}
                    </template>
                    <template #cell(interest_balance)="data">
                        {{ displayNumber(data.item.interest_balance) }}
                    </template>
                    <template #cell(default_interest)="data">
                        {{ displayNumber(data.item.default_interest) }}
                    </template>
                    <template #cell(penalty)="data">
                        {{ displayNumber(data.item.penalty) }}
                    </template>
                    <template #cell(past_due)="data">
                        {{ displayNumber(data.item.past_due) }}
                    </template>
                    <template #cell(provision_for_loan_losses)="data">
                        {{ displayNumber(data.item.provision_for_loan_losses) }}
                    </template>
                </b-table>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-xl-6 col-sm-6 col-12">
                <b-skeleton-wrapper :loading="loading">
                    <template #loading>
                        <b-card class="card-shape home-box">
                            <b-skeleton width="85%" height="20%"></b-skeleton>
                            <b-skeleton width="70%" height="20%"></b-skeleton>
                            <b-skeleton width="30%" height="20%"></b-skeleton>
                            <b-skeleton width="50%" height="20%"></b-skeleton>
                            <b-skeleton width="90%" height="20%"></b-skeleton>
                        </b-card>
                    </template>
<div class="card mb-4 card-shape home-box ">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 class="m-0 fw-bold akkurate-dark">
            Financial Performance Chart
        </h6>
    </div>
    <div class="card-body default-chart-size">
        <div>
            <PerformanceLineChart :lineChartData="lineChartData" />
        </div>
    </div>
</div>
</b-skeleton-wrapper>
</div>
<div class="col-xl-3 col-sm-6 col-12">
    <b-skeleton-wrapper :loading="loading">
        <template #loading>
                        <b-card class="card-shape home-box">
                            <b-skeleton width="85%" height="20%"></b-skeleton>
                            <b-skeleton width="70%" height="20%"></b-skeleton>
                            <b-skeleton width="30%" height="20%"></b-skeleton>
                            <b-skeleton width="50%" height="20%"></b-skeleton>
                            <b-skeleton width="90%" height="20%"></b-skeleton>
                        </b-card>
                    </template>
        <div class="card mb-4 card-shape home-box" style="height: 385px;">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 class="m-0 fw-bold akkurate-dark">Financial Position</h6>
            </div>
            <div class="card-body default-chart-size">
                <div class="pie-chart-area">
                    <DoughnutChart :chartData="chartDataBalanceSheet" />
                </div>
                <hr />
                <div class="row">
                    <div class="col akkurate-blue-text">
                        <div class="small">Assests</div>
                        <div class="akkurate-small">Today:{{ assest_today }}</div>
                        <div class="akkurate-small">Month:{{ assest_month }}</div>
                        <div class="akkurate-small">YTD:{{ assest_year }}</div>
                    </div>
                    <div class="col akkurate-green">
                        <div class="small">Liability & Capital</div>
                        <div class="akkurate-small">{{ lib_today }}</div>
                        <div class="akkurate-small">{{ lib_month }}</div>
                        <div class="akkurate-small">{{ liability_capital_year }}</div>
                    </div>
                </div>
            </div>
        </div>
    </b-skeleton-wrapper>
</div>
<div class="col-xl-3 col-sm-6 col-12">
    <b-skeleton-wrapper :loading="loading">
        <template #loading>
                        <b-card class="card-shape home-box">
                            <b-skeleton width="85%" height="20%"></b-skeleton>
                            <b-skeleton width="70%" height="20%"></b-skeleton>
                            <b-skeleton width="30%" height="20%"></b-skeleton>
                            <b-skeleton width="50%" height="20%"></b-skeleton>
                            <b-skeleton width="90%" height="20%"></b-skeleton>
                        </b-card>
                    </template>
        <div class="card mb-4 card-shape home-box">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 class="m-0 fw-bold akkurate-dark">Income & Expenses</h6>
            </div>
            <div class="card-body default-chart-size">
                <div class="pie-chart-area">
                    <DoughnutChart :chartData="chartDataIncome" />
                </div>
                <hr />
                <div class="row">
                    <div class="col akkurate-danger">
                        <div class="small">Expenses</div>
                        <div class="akkurate-small">Today: {{ expenses_today }}</div>
                        <div class="akkurate-small">Month: {{ expenses_month }}</div>
                        <div class="text-xs">YTD:{{ expenses_year }}</div>
                    </div>
                    <div class="col akkurate-green">
                        <div class="small">Income</div>
                        <div class="akkurate-small"> {{ income_today }}</div>
                        <div class="akkurate-small">{{ income_month }}</div>
                        <div class="text-xs">{{ income_year }}</div>
                    </div>
                    <div class="col akkurate-blue-text">
                        <div class="small">P/L</div>
                        <div class="akkurate-small">{{ profit_loss_today }}</div>
                        <div class="akkurate-small">{{ profit_loss_month }}</div>
                        <div class="text-xs">{{ profit_loss_year }}</div>
                    </div>
                </div>
            </div>
        </div>
    </b-skeleton-wrapper>
</div>
</div> -->
    </div>
</template>
<script>
import DoughnutChart from '../Charts/DoughnutChart.vue'
import ApiService from "@/core/services/api.service";
import PerformanceLineChart from "../Charts/PerformanceLineChart.vue";
export default {
    components: {
        DoughnutChart,
        PerformanceLineChart
    },
    // props:['show'],
    props: {
        showDashboard: {
            type: Boolean,
            default: false
        }
    },
    //   watch: {
    //     // Watch for changes in propA
    //     showDashboard: function(newValue, oldValue) {
    //         console.log("new" + newValue)
    //         console.log("old" + oldValue)
    //       if(newValue === true && newValue !== oldValue) {
    //         // Call your API here
    //         this.getLoanOfficerDashboardApi();
    //       }
    //     }
    //   },
    created() {
        // Call your API here
        this.loadAgingSummary();
    },
    // watch: { 
    // showDashboard: function(newVal, oldVal) { // watch it
    //       console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    //     }
    //   },
    data() {
        return {
            form: {
                start_date: this.getBeginningOfYear(),
                end_date: new Date().toISOString().split('T')[0],
                terms: "Periodic",
                terms_options: ["YTD", "Periodic"],
            },
            roles: "",
            loading: false,
            isLoading: false,
            loan_products: [],
            total_loans_count: "",
            total_loans_amount: "",
            loans_in_arrears_count: "",
            loans_in_arrears_amount: "",
            loans_paid_off_count: "",
            loans_paid_off_amount: "",
            active_loans_count: "",
            active_loans_amount: "",
            balance_sheet_name: [],
            balance_sheet_value: [],
            color_value: [],
            liability_capital: 0,
            expenses: 0,
            income: 0,
            profit_loss: 0,
            lineChartData: {
                labels: [],
                datasets: [],
            },
            chartDataBalanceSheet: {
                labels: [],
                datasets: [],
            },
            chartDataIncome: {
                labels: [],
                datasets: [],
            },
            assest_year: 0,
            assest_today: 0,
            lib_year: 0,
            liability_capital_year: 0,
            expenses_year: 0,
            income_year: 0,
            profit_loss_year: 0,
            lib_today: 0,
            capital_today: 0,
            liability_capital_today: 0,
            income_today: 0,
            expenses_today: 0,
            profit_loss_today: 0,
            assest_month: 0,
            lib_month: 0,
            liability_capital_month: 0,
            income_month: 0,
            expenses_month: 0,
            profit_loss_month: 0,
            age_report_items: [],
            age_report_fields: [
                {
                    label: "Loan Age Group",
                    key: "age_group",
                },
                {
                    label: "Principal Balance",
                    key: "principal_balance",
                },
                {
                    label: "Default Principal",
                    key: "default_principal",
                },
                {
                    label: "Interest PastDue",
                    key: "default_interest",
                },
                {
                    label: "Penal Int.PastDue",
                    key: "penalty",
                },
                {
                    label: "Total PastDue",
                    key: "past_due",
                },
                {
                    label: "Provision_Rate(%)",
                    key: "provision_rate",
                },
                {
                    label: "Provision for loan losses",
                    key: "provision_for_loan_losses",
                },
            ],
            /// KJKJKJJK ///
            search: "Search",
            isBusy: false,
            isSearching: false,
        };

    },
    methods: {
        rowClass() {
            return 'custom-row-height'
        },
        async loadAgingSummary() {
            this.isLoading = true;
            this.search = "Processing...";
            this.isSearching = true;

            await ApiService.post("/reports/loans/aging-analysis-summary", {
                end_date: this.form.end_date,
                term: this.form.terms, //['periodic','YTD]
            })
                .then((response) => {
                    this.isLoading = false;
                    this.age_report_items = response.data.data
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.isSearching = false;
                    this.search = "Search";
                    console.log(error);
                    this.$Progress.fail();
                })
                .finally(() => {
                    this.$Progress.finish();
                });
        }
    },
}
</script>
<style>
.card-top-dashboard {
    min-height: 140px;
}
</style>